import React from 'react';
import {
    Filter,
    SelectInput,
    TextInput
} from 'react-admin';
import { useTranslation } from 'react-i18next';

const DripCampaignFilter = (props) => {
    const { t } = useTranslation();

    return (
        <Filter {...props}>
            <TextInput 
                autoFocus 
                label={t('drip.name')} 
                source='name.value'
                resettable
            />
            <SelectInput 
                source='isActive' 
                choices={[
                    { id: true, name: t('drip.status.active') },
                    { id: false, name: t('drip.status.inactive') },
                ]} 
                label={t('drip.status')} 
                allowEmpty={true}
            />
        </Filter>
    );
}

export default DripCampaignFilter;